import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import logo from "../../../../assets/VZY/HelpSupport-logo.png";
import TicketIcon from "../../../../assets/VZY/tickets.png";
import { useSearchParams } from "react-router-dom";
import { AuthorizeService } from "../../../../services/ContactUS/AuthorizeService";

export const Header = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const navigation = useNavigate();
  const location = useLocation();
  const [tickets, setTickets] = useState([]);
  const [searchParams] = useSearchParams();
  const AuthValidateService = useRef(AuthorizeService());
  const [isAuthValidated, setIsAuthValidated] = useState(false);

  const REDIRECT_URL = "https://vzy.one/en/account";

  const getSessionData = () => {
    try {
      return JSON.parse(sessionStorage.getItem("helpSupportData") || "{}");
    } catch {
      return {};
    }
  };

  useEffect(() => {
    const urlToken = searchParams.get("a_t");
    const urlSid = searchParams.get("sid");
    const urlMno = searchParams.get("mno");

    if (urlToken && urlSid && urlMno) {
      sessionStorage.setItem(
        "helpSupportData",
        JSON.stringify({
          token: urlToken,
          sid: urlSid,
          mno: urlMno,
        }),
      );
      return;
    }

    const storedData = getSessionData();
    const isTokenEmpty = !storedData?.token?.trim();
    const isSidEmpty = !storedData?.sid?.trim();
    const isSidZero = Number(storedData?.sid) === 0;
    const isMnoEmpty = !storedData?.mno?.trim();

    if (isTokenEmpty || isSidEmpty || isMnoEmpty || isSidZero) {
      window.location.replace(REDIRECT_URL);
    }
  }, [searchParams]);

  const validateAuth = useCallback(async () => {
    if (isAuthValidated) return;

    try {
      const storedData = getSessionData();
      const token = String(storedData?.token || "").trim();
      const sid = String(storedData?.sid || "").trim();
      const mno = String(storedData?.mno || "").trim();

      if (!token || !sid || !mno || Number(sid) === 0) {
        console.warn("Invalid session data");
        window.location.replace(REDIRECT_URL);
        return;
      }

      const payload = {
        MobileNo: String(mno || "").replace(/^91-/, ""), //mno,
        OTTSMSID: sid,
        Source: "VZY_SUPPORT",
        AuthToken: searchParams.get("a_t") || token,
      };

      const response = await AuthValidateService?.current?.Auth(payload);
      // debugger;
      if (response?.data === true) {
        console.log("Auth valid");
        setIsAuthValidated(true);
      } else {
        console.warn("Auth failed:", response);
        window.location.replace(REDIRECT_URL);
      }
    } catch (error) {
      console.error("validateAuth error:", error);
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        window.location.replace(REDIRECT_URL);
      }
    }
  }, [isAuthValidated]);

  useEffect(() => {
    const timer = setTimeout(() => {
      validateAuth();
    }, 100);
    return () => clearTimeout(timer);
  }, [validateAuth]);

  const fetchTicketList = useCallback(async () => {
    try {
      const storedData = getSessionData();
      const sid = storedData?.sid || "";
      if (!sid) return;

      const payload = { OttSMSId: sid };
      const response = await axios.post(
        `${apiBaseURL}/api/v1/ContactUs/vzy-complain`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      setTickets(response?.data?.data || []);
    } catch (err) {
      console.error("fetchTicketList error:", err);
      setTickets([]);
    }
  }, [apiBaseURL]);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedData = getSessionData();
      if (storedData?.sid) {
        clearInterval(interval);
        fetchTicketList();
      }
    }, 300);

    const timeout = setTimeout(() => clearInterval(interval), 10000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [fetchTicketList]);

  return (
    <header>
      <div className="container">
        <nav className="navbar">
          <a className="navbar-brand">
            <img
              style={{ cursor: "pointer" }}
              onClick={() => navigation("/VZYSupport/helpSupport")}
              src={logo}
              alt="Logo"
            />
          </a>
          <form className="form-inline d-flex align-items-center">
            {/* <label className="mr-2 mb-0">Language</label>
            <select
              className="form-control-language"
              defaultValue="en"
              disabled
            >
              <option value="">Select</option>
              <option value="en">English</option>
            </select> */}

            {!location.pathname.startsWith("/VZYSupport/MyTickets") &&
              tickets.length > 0 && (
                <span
                  className="my-ticket-btn"
                  onClick={() => navigation("/VZYSupport/MyTickets")}
                >
                  <img src={TicketIcon} alt="My Tickets" />
                  My Tickets
                </span>
              )}
          </form>
        </nav>
      </div>
    </header>
  );
};
